/* istanbul ignore file */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo, useContext, createContext } from 'react';
import styled from 'styled-components';
import {
  ModalContainer,
  ModalTitleAndCloseContainer,
  ModalContentsInner,
  ModalCloseButton,
  ModalCloseIcon,
  ModalContentsOuter,
  MuiModal,
  ModalScrollableContainerInner,
  ModalScrollableContainerOuter,
  ModalTitle,
  ModalConfirmButton,
  ModalCancelButton,
  ModalActionsContainer,
} from './ModalStyles';

const ModalContext = createContext({ onClose: () => {} });
ModalContext.displayName = 'ModalContext';

function useModalContext() {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error('useModalContext must be used within a <Modal />');
  }
  return context;
}
export const ModalContents: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, ...props }) => (
  <ModalContentsOuter {...props}>
    <ModalContentsInner {...props}>
      {children}
    </ModalContentsInner>
  </ModalContentsOuter>
);

export const ModalTitleAndClose: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children, ...props }) => {
  const { onClose } = useModalContext();
  return (
    <ModalTitleAndCloseContainer {...props}>
      {children}
      <ModalCloseButton data-automation="ModalCloseButton" type="button" tabIndex={0} onClick={onClose}>
        <ModalCloseIcon />
      </ModalCloseButton>
    </ModalTitleAndCloseContainer>
  );
};

interface ModalProps extends React.HTMLAttributes<HTMLDivElement> {
    suppressHotjar?: boolean;
    onClose: () => void;
    isOpen: boolean;
    children: React.ReactNode;
    className?: string;
}

export const Modal: React.FC<ModalProps> = props => {
  const {
    suppressHotjar,
    onClose,
    isOpen,
    children,
    className,
    ...remainingProps
  } = props;
  const modalContext = useMemo(() => ({
    onClose,
  }), [onClose]);
  return (
    <MuiModal
      open={isOpen}
      onClose={onClose}
      {...remainingProps}
    >
      <ModalContext.Provider value={modalContext}>
        <ModalContainer data-hj-suppress={suppressHotjar} className={className}>
          {children}
        </ModalContainer>
      </ModalContext.Provider>
    </MuiModal>
  );
};

export { ModalTitle, ModalConfirmButton, ModalCancelButton, ModalActionsContainer, ModalScrollableContainerOuter, ModalScrollableContainerInner };

export const TemplateManagerModalContents = styled(ModalContents)`
  min-height: 16rem;
  height: 100%;
  overflow: hidden;
  background: rgb(248, 246, 247);
  padding-bottom: 20px;

  ${ModalContentsOuter} {
    border-radius: 0.5rem;
  }

  ${ModalContentsInner} {
    padding: 0;
    display: grid;
    grid-template-columns: 2fr 3fr;
    overflow: hidden;
    grid-template-rows: 100%;
  }
`;
